<template>
  <div>
    <dt>{{ label }}</dt>
    <dd>{{ value }}</dd>
  </div>
</template>

<script>
export default {
  name: "view-c-protocolo-disciplina-multipla",
  props: {
    label: String,
    value: Array
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/View/DisciplinaMultipla.vue